import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-simple',
    templateUrl: './simple.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SimpleComponent {

  constructor(
  ) { }
}
